import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
import _ from "lodash";
//import _ from 'lodash';

class AgenciesSearch extends Component {
	render() {
		const { agencies, entities, versions } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<div className="select is-small">
					<select name="type" id="type" value={agencies.filters.agenciable_type} onChange={this._typeChange}>
						<option value="">--- Tipo ---</option>
						<option value="federal">FEDERAL</option>
						<option value="imm">IMM</option>
						<option value="imef">IMEF</option>
						<option value="cdm">CDM</option>
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${versions.isFetching ? ' is-loading' : ''}`}>
					<select name="version_id" id="version_id" disabled={versions.isFetching} value={agencies.filters.version_id} onChange={this._versionChange}>
						<option value=" " defaultValue>--- Año ---</option>
						{_.map(versions.list,(version, k) => {
							return <option value={version.id} key={k}>{version.year}</option>
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<div className={`select is-small${entities.isFetching ? ' is-loading':''}`} >
					<select name="state_id" id="state_id" value={agencies.filters.state_id} onChange={this._entityChange}>
						<option value="">--- Entidad ---</option>
						{_.map(entities.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={agencies.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._typeChange = this._typeChange.bind(this);
		this._versionChange = this._versionChange.bind(this);
		this._entityChange = this._entityChange.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	componentWillMount(){
		this.props.fetchEntities();
		this.props.versionsList();
	}

	_submitSearch() {
		const {agencies} = this.props;
		this.props.agenciesShow(1,agencies.filters);
	}

	_typeChange(event){
		this.props.change('agencies.filters.agenciable_type',event.target.value);
	}

	_versionChange(event){
		this.props.change('agencies.filters.version_id',event.target.value);
	}

	_entityChange(event){
		this.props.change('agencies.filters.state_id',event.target.value);
	}

	_searchChange(event){
		this.props.change('agencies.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('agencies.filters');
		this.props.agenciesShow(1);
	}
}

export default SecureLayout(AgenciesSearch);



// WEBPACK FOOTER //
// ./src/elements/agencies/widget/agencies_search.jsx